import React from 'react';
import { Box, Flex, Text } from '@spothero/ui';
import { ReviewRentalDetails } from './ReviewRentalDetails';
import { ReviewPromptsList } from './ReviewPromptsList';
import { StarRating } from 'common/star-rating';
import dayjs from 'utils/dayjs';
import TimeUtils from 'utils/time';
export const ReviewItem = ({ review }) => {
    const { star_rating, rental, prompts, created } = review;
    const formattedReviewDate = dayjs(created).format('MMMM D, YYYY');
    const rentalDuration = rental.rental_type === 'monthly'
        ? 'Monthly parking'
        : TimeUtils.prettyDuration(dayjs(rental.ends).diff(dayjs(rental.starts)));
    return (<Box border="1px solid" borderColor="gray.200" borderRadius="md" padding={4} marginRight={2} data-testid="ReviewItem">
            <Flex justifyContent="space-between" alignItems="flex-start" marginBottom={2}>
                <StarRating rating={star_rating}/>
                <Text fontSize="xs" color="gray.dark">
                    {formattedReviewDate}
                </Text>
            </Flex>

            <ReviewRentalDetails vehicleType={rental.make_model} duration={rentalDuration} destination={rental.venue}/>

            <ReviewPromptsList prompts={prompts}/>
        </Box>);
};
